<script setup lang="ts">
import Heading from "~/components/atoms/Heading.vue";
import Breadcrumbs from "~/components/organisms/Breadcrumbs.vue";

const props = defineProps({
  breadcrumbs: {
    type: Array,
    default: []
  }
});
</script>

<template>
  <div class="base-page g-32">
    <div class="container" v-if="props.breadcrumbs?.length || $slots.preH1 || $slots.title || $slots.subheading">
      <div class="heading g-24 shorter-gap">
        <Breadcrumbs v-if="props.breadcrumbs" :breadcrumbs="props.breadcrumbs"/>
        <div class="row g-8" v-if="$slots.preH1 || $slots.title">
          <slot name="preH1"/>
          <Heading v-if="$slots.title" tag="h1">
            <slot name="title"/>
          </Heading>
        </div>
        <Heading v-if="$slots.subheading" font-size="12px" font-weight="400" tag="h2">
          <slot name="subheading"/>
        </Heading>
      </div>
    </div>
    <slot/>
  </div>
</template>
